import MaterialGroup from './MaterialGroup';

export default MaterialGroup;
